// strings separadas por espaço
export const REGEX_FULL_NAME = /^[\wÀ-ú]{3,}(?:\s{1,}[\wÀ-ú]+){1,9}$/g;

export const REGEX_FULL_NAME_WITH_SPACES = /( )+/g

// Somente letras e espaços
export const REGEX_LETTERS_SPACES = /^[A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ ]+$/;

export const REGEX_URL_ROOMID = /(&roomId=\["(\w+)"\])*/g;